// extracted by mini-css-extract-plugin
export default {"sub-category__image":"sub-category__image_xDH_H3e0"};